module.exports = __webpack_public_path__ + "static/influencer-cover.8f8645c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/influencer-cover.jpg
// module id = 473
// module chunks = 207076274901000